import {
  ledgerEthereum,
  ledgerLiveEthereum,
  ledgerEthereumClassic,
  ledgerLiveEthereumClassic,
  ropsten,
  rskMainnet,
  rskTestnet,
  thundercore,
  solidum
} from './paths';
export default [
  ledgerEthereum,
  ledgerLiveEthereum,
  ledgerEthereumClassic,
  ledgerLiveEthereumClassic,
  ropsten,
  rskMainnet,
  rskTestnet,
  thundercore,
  solidum
];
